import type { PaletteOptions } from '@mui/material/styles';
import { grey } from '../colors';

const palette: Partial<PaletteOptions> = {
  contrastThreshold: 4.5,
  grey: {
    50: grey[20],
    100: grey[40],
    200: grey[60],
    300: grey[80],
    400: grey[100],
    500: grey[120],
    600: grey[140],
    700: grey[160],
    800: grey[180],
    900: grey[200],
    A100: grey[60],
    A200: grey[100],
    A400: grey[200],
  },
};

export default palette;
